import { useEffect, useState } from "react";
import { API } from "../../config/constants";
import Toggle from "../../utils/Toggle";
import ContentLoader from "../../utils/ContentLoader";
import Scroller from "../../utils/Scroller";

export default function UserForm({ onSubmit, initialData = {}, roleName }) {
  const isEdit = Boolean(initialData?.id);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    role_id: "",
    name: "",
    email: "",
    gender: "",
    contact: "",
    icon: null,
    password: "",
    active: true,
  });
  // Prefill when editing
  useEffect(() => {
    if (initialData?.id) {
      setFormData({
        role_id: initialData.role_id ?? "",
        name: initialData.name ?? "",
        email: initialData.email ?? "",
        gender: initialData.gender ?? "",
        contact: initialData.contact ?? "",
        icon: initialData.icon,
        iconUrl: initialData.icon ? `${API.IMAGE_BASE_URL}/${initialData.icon}` : "/assets/images/logo-profile.png",
        password: "",
        active: initialData.active ?? true,
      });
    }
  }, [initialData]);

  // Handle Change
  const handleChange = (e) => {
    const { name, value, type, files, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "file" ? files[0] :
          type === "checkbox" ? checked :
            value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  // Validation
  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!isValidEmail(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }
    if (!formData.gender.trim()) newErrors.gender = "Gender is required";
    if (!formData.contact.trim()) newErrors.contact = "Contact is required";
    if (!formData.role_id) newErrors.role_id = "Role ID is required";
    if (!isEdit && !formData.icon) newErrors.icon = "Icon is required";

    if (!isEdit) {
      if (!formData.password.trim()) {
        newErrors.password = "Password is required";
      } else if (formData.password.length < 8) {
        newErrors.password = "Password must be at least 8 letters";
      }
    }

    if (formData.contact && !/^\+?\d{7,15}$/.test(formData.contact)) {
      newErrors.contact = "Enter valid contact number";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  // Submit
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      setLoading(true);
      onSubmit(formData);
    } catch (err) {
      console.error("Submission failed:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <ContentLoader />;

  return (
    <div className="col-lg-12">
      <div className="card" style={{ marginTop: "10px" }}>
        <div className="card-header">
          <h5 className="card-title mb-0">
            {isEdit ? "Edit User" : "Create User"}
          </h5>
        </div>

        <div className="card-body ">
          <form className="row gy-3" onSubmit={handleSubmit} noValidate>

            {/* Name */}
            <div className="col-md-6">
              <label className="form-label">
                Full Name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="text"
                name="name"
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                value={formData.name || ""}
                onChange={handleChange}
                placeholder="Enter Name"
              />
              {errors.name && <div className="invalid-feedback">{errors.name}</div>}
            </div>
            {/* Gender */}
            <div className="col-md-6">
              <label className="form-label">
                Gender <span style={{ color: "red" }}>*</span>
              </label>
              {/* <select
                name="gender"
                className={`form-select ${errors.gender ? "is-invalid" : ""}`}
                value={formData.gender || ""}
                onChange={handleChange}
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select> */}
              <Scroller
                options={[
                  { label: "Male", value: "male" },
                  { label: "Female", value: "female" },
                  { label: "Other", value: "other" }
                ]}
                value={
                  formData.gender
                    ? {
                      label:
                        formData.gender.charAt(0).toUpperCase() +
                        formData.gender.slice(1),
                      value: formData.gender
                    }
                    : null
                }
                onChange={(sel) =>
                  setFormData((prev) => ({
                    ...prev,
                    gender: sel?.value || ""
                  }))
                }
                placeholder="Select Gender"
                isClearable={false}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    height: "44px",
                    minHeight: "44px",
                    borderRadius: "6px",
                  })
                }}
              />
              {errors.gender && <div className="invalid-feedback">{errors.gender}</div>}
            </div>
            {/* Contact */}
            <div className="col-md-6">
              <label className="form-label">
                Contact <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="number"
                name="contact"
                className={`form-control ${errors.contact ? "is-invalid" : ""}`}
                value={formData.contact || ""}
                onChange={handleChange}
                placeholder="Enter Contact"
              />
              {errors.contact && <div className="invalid-feedback">{errors.contact}</div>}
            </div>
            {/* Email */}
            <div className="col-md-6">
              <label className="form-label">
                Email <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="email"
                name="email"
                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                value={formData.email || ""}
                onChange={handleChange}
                placeholder="Enter Email ID"
              />
              {errors.email && <div className="invalid-feedback">{errors.email}</div>}
            </div>
            {/* Password */}
            <div className="col-md-6">
              <label className="form-label">
                Password <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="password"
                name="password"
                className={`form-control ${errors.password ? "is-invalid" : ""}`}
                value={formData.password || ""}
                onChange={handleChange}
                required={!isEdit}
                placeholder="Enter Password"
              />
              {errors.password && <div className="invalid-feedback">{errors.password}</div>}
            </div>
            {/* Role */}
            <div className="col-md-6">
              <label className="form-label">
                Role <span style={{ color: "red" }}>*</span>
              </label>
              {/* <select
                name="role_id"
                className={`form-select ${errors.role_id ? "is-invalid" : ""}`}
                value={formData.role_id}
                onChange={handleChange}
              >
                <option value="">Select Role</option>
                {roleName.map((role) => (
                  <option key={role.id} value={role.id}>
                    {role.name}
                  </option>
                ))}
              </select> */}
              <Scroller
                options={roleName.map((role) => ({
                  label: role.name,
                  value: role.id
                }))}
                value={
                  formData.role_id
                    ? {
                      label:
                        roleName.find((r) => r.id === formData.role_id)?.name || "",
                      value: formData.role_id
                    }
                    : null
                }
                onChange={(sel) =>
                  setFormData((prev) => ({
                    ...prev,
                    role_id: sel?.value || ""
                  }))
                }
                placeholder="Select Role"
                isClearable={false}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    height: "44px",
                    minHeight: "44px",
                    borderRadius: "6px",
                  })
                }}
              />
              {errors.role_id && <div className="invalid-feedback">{errors.role_id}</div>}
            </div>

            {/* Status */}
            <div className="col-md-6" style={{ marginTop: "20px" }}>
              <label className="form-label mb-2">Status</label>
              <div style={{ marginLeft: "0" }}>
                <Toggle
                  value={formData.active}
                  onChange={(value) => {
                    setFormData((prev) => ({
                      ...prev,
                      active: value,
                    }));
                  }}
                />
              </div>
            </div>

            {/* Icon */}
            <div className="col-md-6">
              <label className="form-label">Profile picture</label>
              {/* Single preview block */}
              {(formData.previewImage || (isEdit && formData.iconUrl)) && (
                <div className="mt-2">
                  <img
                    src={formData.previewImage || formData.iconUrl}
                    alt="Preview"
                    style={{
                      width: "60px",
                      height: "60px",
                      objectFit: "cover",
                      borderRadius: "4px",
                      border: "1px solid #ddd",
                      marginBottom: 10
                    }}
                  />
                </div>
              )}
              <input
                type="file"
                name="icon"
                className={`form-control ${errors.icon ? "is-invalid" : ""}`}
                onChange={(e) => {
                  handleChange(e);
                  const file = e.target.files?.[0];
                  if (file) {
                    setFormData((prev) => ({
                      ...prev,
                      previewImage: URL.createObjectURL(file),
                    }));
                  }
                }}
              />

              {errors.icon && <div className="invalid-feedback">{errors.icon}</div>}
            </div>

            {/* Submit */}
            <div className="col-12 d-flex justify-content-end  mt-3">
              <button className="btn btn-primary-600" type="submit" style={{ borderRadius: "4px" }}>
                {isEdit ? "Update User" : "Create User"}
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
}
